import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Typography,
  TablePagination,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import * as React from "react";
import { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import { backendCall, scoreCall } from "../utils/Network";
import { GlobalContext } from "../utils/GlobalContext";
import { showLocalNum } from "../utils/utils.js";


import * as XLSX from 'xlsx';

import "../CSS/Layout.css";

const CheckSimilarityTable = ({
  description,
  maxQuery,
  state,
  smartSearch,
  includeDocs,
    exportExcel
}) => {
  const [projectList, setProjectList] = useState(null);
  const [noData, setNoData] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [page, setPage] = useState(0);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    let stateIds;
    if (state.length > 0) {
      stateIds = state.map((state) => state.state_id);
    } else {
      stateIds = null;
    }
    const fetchSimilarProjects = async () => {
      setNoData(false);
      setIsLoading(true);
      try {
        const body = {
          //   query: "transit department",
          state_ids: stateIds,
          query: description,
          max_project: maxQuery,
        };
        console.log(body);
        const response = await scoreCall.post(
          "/get_similar_projects_new",
          body
        );

        console.log(response.data);
        if (response.data !== null) {
          setIsLoading(false);
          // return response;




        }
        if (response.data.length === 0) {
          setNoData(true);
          return;
        } else {
          setProjectList(response.data);
        }
      } catch (error) {
        console.log(error);
      }
    };

    const fetchKeyWordProjects = async () => {
      setNoData(false);
      setIsLoading(true);
      try {
        const body = {
          keyword: description,
          state_ids: stateIds,
          is_include_doc: includeDocs,
        };
        console.log(body);
        const response = await backendCall.post("projectview_by_keyword", body);

        if (response.data !== null) {
          setIsLoading(false);

        }
        if (response.data.length === 0) {
          setNoData(true);
          return;
        } else {
          setProjectList(response.data);
        }
      } catch (error) {
        console.log(error);
      }
    };




    const fetchExportProjects = async () => {

      try {
        const body = {
          keyword: description,
          state_ids: stateIds,
          is_include_doc: includeDocs,
        };
        console.log(body);
        const response = await backendCall.post("projectview_by_keyword", body);

        if (response.data !== null) {



          let text =
              "Project Name, Project Description,State ,Applicants ,Program Name,Funding Opprtunity ,Funding Amount";

          const dataToExport = response.data.map((row) => ({

            ProjectName: row.project_name,
            ProjectDescription: row.project_description,
            StateName: row.state_name,
            Applicants: row.organization_name,
            ProgramName: row.program_name,
            FundingOpportunity: row.title,
            FundingAmount: row.cost,

          }));


          const ws = XLSX.utils.json_to_sheet(dataToExport);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, 'ProjectList');
          XLSX.writeFile(wb, 'project_list.xlsx');


        }
        if (response.data.length === 0) {
          alert('No data to download');
          setNoData(true);
          return;

        } else {
          setProjectList(response.data);
        }
      } catch (error) {
        console.log(error);
      }

    };







    if (smartSearch === true) {
      fetchSimilarProjects();
    }
    if (smartSearch === false) {
      fetchKeyWordProjects();
    }
    if(exportExcel === true){
      fetchExportProjects();
    }
  }, [description, state, smartSearch,exportExcel, includeDocs]);
































  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  return (
        <Box>
      {noData && (
        <Typography variant="h3" color="gray" margin="60px auto">
        Your search returns no projects. Please contact us for targeted
        technical assistance.
        </Typography>
      )}
      {!noData && isLoading && (
        <Box display="flex" justifyContent="center">
          <CircularProgress sx={{ m: 4 }} color="primary" />
        </Box>
      )}
      {!noData && !isLoading && (
        <Box>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <StyledTableCell sx={{ fontWeight: "bold" }}>
                    Project Name
                  </StyledTableCell>
                  <StyledTableCell align="left" sx={{ fontWeight: "bold" }}>
                    Project Description
                  </StyledTableCell>
                  <StyledTableCell align="left" sx={{ fontWeight: "bold" }}>
                    State
                  </StyledTableCell>
                  <StyledTableCell align="left" sx={{ fontWeight: "bold" }}>
                    Applicants
                  </StyledTableCell>
                  <StyledTableCell align="left" sx={{ fontWeight: "bold" }}>
                    Program Name
                  </StyledTableCell>
                  <StyledTableCell align="left" sx={{ fontWeight: "bold" }}>
                    Funding Opportunity
                  </StyledTableCell>
                  <StyledTableCell align="left" sx={{ fontWeight: "bold" }}>
                    Funding Amount
                  </StyledTableCell>

                  {/* For test purpose only */}
                  {/* <StyledTableCell align="left" sx={{ fontWeight: "bold" }}>
                    Score
                  </StyledTableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {projectList
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => (
                    <StyledTableRow
                      key={row.project_id}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <StyledTableCell
                        // F5F5F5 original hover color
                        sx={{
                          "&:hover": {
                            backgroundColor: "#e0e0e0",
                            cursor: "default",
                          },
                        }}
                        onClick={() => {
                          // redirectPath("/projectdetail/" + row.id + "/");
                          const url = "/projectdetail/" + row.project_id + "/";
                          window.open(url, "_blank");
                        }}
                        component="th"
                        scope="row"
                      >
                        {row.project_name}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {row.project_description}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {row.second_state_name
                          ? row.state_name + ", " + row.second_state_name
                          : row.state_name}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {row.second_organization_name
                          ? row.organization_name +
                            ", " +
                            row.second_organization_name
                          : row.organization_name}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {row.program_name}
                      </StyledTableCell>
                      <StyledTableCell
                        sx={{
                          "&:hover": {
                            backgroundColor: "#e0e0e0",
                            cursor: "default",
                          },
                        }}
                        align="left"
                        onClick={() => {
                          // redirectPath("/projectdetail/" + row.id + "/");
                          const url = "/nofodetail/" + row.nofo_id + "/";
                          window.open(url, "_blank");
                        }}
                      >
                        {row.title}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {"$" + showLocalNum(row.cost)}
                      </StyledTableCell>
                      {/* For test purpose only */}
                      {/* <StyledTableCell align="left">
                        {"%" + (row.score * 100).toFixed(2)}
                      </StyledTableCell> */}
                    </StyledTableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[50]}
            component="div"
            count={projectList.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            // onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Box>
      )}
    </Box>
  );
};

export default CheckSimilarityTable;
